<template>
  <div class="cabys-container">
    <!-- BARRA SUPERIOR SOBRIA -->
    <div class="cabys-header pa-4 primary d-flex align-center">
      <v-icon color="white" class="mr-3">mdi-barcode-scan</v-icon>
      <div>
        <h2 class="text-h6 white--text font-weight-bold line-height-1">Seleccionar Código Cabys</h2>
        <span class="caption white--text opacity-70">Listado oficial de bienes y servicios (Hacienda)</span>
      </div>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="close()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>

    <div class="pa-6">
      <!-- ÁREA DE BÚSQUEDA -->
      <v-row align="center">
        <v-col cols="12" sm="9">
          <v-text-field
            v-model="cabysDescripcion"
            label="Buscar por descripción o código (mín. 3 caracteres)"
            placeholder="Ej: Arroz, Mantenimiento, 2312..."
            outlined
            dense
            rounded
            clearable
            hide-details
            prepend-inner-icon="mdi-magnify"
            @keyup.enter="getData"
            class="elevation-0"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="3">
          <v-btn
            color="primary"
            block
            rounded
            depressed
            height="40"
            :loading="loading"
            :disabled="!cabysDescripcion || cabysDescripcion.length < 2"
            @click="getData"
          >
            Buscar
          </v-btn>
        </v-col>
      </v-row>

      <!-- TABLA DE RESULTADOS PREMIUM -->
      <v-card outlined class="rounded-xl mt-6 overflow-hidden border-light">
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          :loading="loading"
          class="modern-table clickable-rows"
          :items-per-page="8"
          no-data-text="No se han realizado búsquedas o no hay resultados."
          loading-text="Consultando a Hacienda... por favor espere"
          @click:row="selected"
        >
          <template v-slot:top>
            <div class="px-4 py-2 grey lighten-5 d-flex align-center border-bottom">
              <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-filter-variant"
                label="Filtrar resultados locales..."
                single-line
                hide-details
                dense
                flat
                background-color="transparent"
                class="compact-filter"
              ></v-text-field>
              <v-spacer></v-spacer>
              <span class="caption grey--text font-weight-medium" v-if="items.length > 0">
                {{ items.length }} resultados encontrados
              </span>
            </div>
          </template>

          <template v-slot:[`item.codigo`]="{ item }">
            <span class="font-weight-bold primary--text">{{ item.codigo }}</span>
          </template>

          <template v-slot:[`item.impuesto`]="{ item }">
            <v-chip small label class="rounded-lg font-weight-bold" color="success lighten-5" text-color="success">
              {{ item.impuesto }}% IVA
            </v-chip>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              color="primary"
              small
              rounded
              depressed
              class="text-none px-4"
              @click.stop="selected(item)"
            >
              Seleccionar
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    allwedOnly: {
      type: Boolean,
      default: true,
    },
    initialQuery: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      search: "",
      loading: false,
      headers: [
        { text: "Código", value: "codigo", width: 140, sortable: true },
        { text: "Descripción", value: "descripcion", sortable: true },
        { text: "Impuesto", value: "impuesto", width: 120, align: 'center', sortable: true },
        { text: "", value: "actions", width: 120, align: 'right', sortable: false },
      ],
      items: [],
      cabysDescripcion: this.initialQuery || "",
    };
  },

  mounted() {
    if (this.cabysDescripcion && this.cabysDescripcion.length >= 2) {
      this.getData();
    }
  },

  methods: {
    getData() {
      if (!this.cabysDescripcion || this.cabysDescripcion.length < 2) return;
      
      this.loading = true;
      this.items = [];
      let me = this;
      
      axios.get("https://api.hacienda.go.cr/fe/cabys?q=" + encodeURIComponent(this.cabysDescripcion))
        .then(function (response) {
          if (response.data && response.data.cabys && response.data.cabys.length > 0) {
            me.items = response.data.cabys;
            me.loading = false;
          } else {
            me.getDataByCode(); 
          }
        })
        .catch(function (error) {
          console.error(error);
          me.loading = false;
        });
    },

    getDataByCode() {
      let me = this;
      axios.get("https://api.hacienda.go.cr/fe/cabys?codigo=" + encodeURIComponent(this.cabysDescripcion))
        .then(function (response) {
          if (Array.isArray(response.data)) {
            me.items = response.data;
          } else if (response.data && response.data.codigo) {
            me.items = [response.data];
          }
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(function() {
          me.loading = false;
        });
    },

    selected(item) {
      this.$emit("clicked", item);
    },

    close() {
      this.$emit("closed");
    },
  },
};
</script>

<style scoped>
.cabys-container {
  background: #ffffff;
}

.theme--dark .cabys-container {
  background: #0f172a;
}

.cabys-header {
  border-radius: 0 0 0 24px;
}

.modern-table {
  background: transparent !important;
}

.modern-table >>> thead th {
  background-color: #f8fafc !important;
  text-transform: uppercase;
  font-size: 0.7rem !important;
  font-weight: 700 !important;
  color: #64748b !important;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #f1f5f9 !important;
}

.theme--dark .modern-table >>> thead th {
  background-color: #1e293b !important;
  color: #94a3b8 !important;
  border-bottom: 2px solid #334155 !important;
}

.clickable-rows >>> tbody tr {
  cursor: pointer;
  transition: all 0.2s;
}

.clickable-rows >>> tbody tr:hover {
  background-color: rgba(16, 185, 129, 0.03) !important;
  transform: translateX(4px);
}

.border-light {
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
}

.theme--dark .border-light {
  border: 1px solid rgba(255, 255, 255, 0.05) !important;
}

.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05) !important;
}

.compact-filter {
  max-width: 300px;
}

.line-height-1 {
  line-height: 1.2;
}

.opacity-70 {
  opacity: 0.7;
}
</style>